var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8833 7.64091C1.8833 7.7786 2.00854 7.89756 2.14628 7.89681C2.19267 7.89659 2.23065 7.89659 2.245 7.89659C4.80826 7.89659 6.66808 9.77499 6.66808 12.3385C6.66808 12.2799 6.66808 12.2969 6.66771 12.3443C6.66667 12.4892 6.80107 12.6297 6.9461 12.6297H12.6862C14.6699 12.6297 15.9999 11.2328 15.9999 9.15975V5.89039C15.9999 5.76729 15.9001 5.66748 15.777 5.66748H2.10619C1.98309 5.66748 1.8833 5.76728 1.8833 5.89039V7.64091Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20028 0.799805H12.6828C14.6666 0.799805 15.9995 2.19449 15.9995 4.26979V4.32923C15.9995 4.45234 15.8996 4.55214 15.7766 4.55214H2.10727C1.98416 4.55214 1.88437 4.45234 1.88437 4.32923V4.26979C1.88437 2.19449 3.21727 0.799805 5.20028 0.799805ZM3.10935 11.4191H4.54701C4.8546 11.4191 5.10424 11.6688 5.10424 11.9764C5.10424 12.284 4.8546 12.5337 4.54701 12.5337H3.10935V13.97C3.10935 14.2783 2.85971 14.5272 2.55212 14.5272C2.39833 14.5272 2.25939 14.4648 2.15834 14.3645C2.0573 14.2635 1.99489 14.1245 1.99489 13.97V12.5337H0.557232C0.403436 12.5337 0.263756 12.4713 0.163455 12.3702C0.06241 12.2692 0 12.1302 0 11.9764C0 11.668 0.24964 11.4191 0.557232 11.4191H1.99489V9.98208C1.99489 9.67447 2.24453 9.4248 2.55212 9.4248C2.85971 9.4248 3.10935 9.67447 3.10935 9.98208V11.4191Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCreditCard);
export default __webpack_public_path__ + "static/media/add_credit_card.f5a9c674.svg";
export { ForwardRef as ReactComponent };